import type { ReactNode } from 'react';
import { Svg } from '../primitives/Svg.js';
import type { IconProps } from '../primitives/types.js';

/** Tag — angled label with a string-hole at the tip. Distinct from
 *  the bookmark glyph: a tag is the wedge-shape jewellery /
 *  price-label silhouette, with a visible eyelet circle. Means
 *  "label / tag / category mark" in the taxonomy picker. */
export function IcnTag(props: IconProps): ReactNode {
  return (
    <Svg {...props} iconName="tag">
      {/* Outline */}
      <path d="M2.5 7 L7 2.5 H13 V8.5 L8.5 13 Z" />
      {/* Eyelet */}
      <circle cx="6.2" cy="6.2" r="1" />
    </Svg>
  );
}
